/**************************************** zmf 重构开发 执行公共页面跳转工具类 ******************************************/
import * as util from '@static/js/util.js';
import * as funRouter from '@pageRouter/funRouter'
import { inspectResTimes, inspectResDulTime } from '@service/getData'
/***
 *
 * @param context
 * @param url
 */
const openPdfview = function (context, fileId, url, saveNameStr) {

  if (!url) {
    weui.alert("参数错误");
    return;
  }

  let fileType = util.getFileType(saveNameStr);
  var previewUrl = context.getFilePreview(url);
  if (previewUrl != '') {
    context.$router.push({ path: context.$route.path, query: { preview: fileId } })
    var u = navigator.userAgent;
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)

    var userobj = window.sessionStorage.getItem('SC_USER');
    var token, userId, type;
    if (userobj != undefined && userobj != null && userobj != 'undefined') {
      var user = JSON.parse(userobj);
      token = user.token;
      userId = user.id;
      type = user.type;
    }

    if (isiOS && fileType == 'pdf') {
      if (!context.utils.isEmpty(token) && !context.utils.isEmpty(userId)) {
        url = url + '?token=' + token + '&userId=' + userId;
      } else {
        weui.alert("用户id过期，请退出重试！");
        return;
      }

	  return context.$router.push({path:"/pdfView",query: { url: saveNameStr } });
        //$('#res_iframe')[0].contentWindow.location.replace(pdfUrl);
    } else {
      if (!context.utils.isEmpty(token) && !context.utils.isEmpty(userId)) {
        previewUrl = previewUrl + '?token=' + token + '&userId=' + userId;
      } else {
        weui.alert("用户id过期，请退出重试！");
        return;
      }

      let data = {}
      data.id = fileId;
      data.classId = 1;
      data.url = previewUrl;
      openUrllink(context,data);

      //$('#res_iframe')[0].contentWindow.location.replace(previewUrl);
    }
	setTimeout(function () {
		$('#res_iframe_box').hide();
	}, 100);
  }
};

/**
 *
 * @param context
 * @param url
 */
export const openUrllink = (context,data,fromExternal = false) => {
  if (fromExternal) {

  context.loading = weui.loading('正在加载')
  inspectResTimes(context, data.id, data.classId)
    .then(function (response) {
      if (!response.data.success) {
        console.log('link统计接口: ' + response.data.info);
      }
      
      // 外链无法统计具体时间，所以固定设置个5秒，让后台可以统计到数据
      inspectResDulTime(context, data.id, data.classId, 5)
        .then(response => {
          context.loading.hide()
          window.location.href = data.url
        }).catch(error => {
          context.loading.hide()
          console.log(error);
        })

    }).catch(function (error) {
      context.loading.hide()
      console.log(error);
    });
    return

}
	return context.$router.push({path:"/previewUrl",query: { url: data.url } });
}
/**
 *
 * @param context
 * @param url
 * @param saveName 必须包含类型
 * @param el
 * @param type
 */
export const openAssetsShow = (context, el, url, saveName, saveNameStr, fileId, classId, type = true) => {
  if (!url) {
    weui.alert("参数错误");
    return;
  }

  //增加统计接口
  //context.$axios.post(context.stuApiUrl + "/courseware/file/read", context.$qs.stringify({fileId : fileId, classId : classId}))
  inspectResTimes(context, fileId, classId)
    .then(function (response) {
      if (!response.data.success) {
        console.log('统计接口: ' + response.data.info);
      }
    }).catch(function (error) {
      console.log(error);
    });

  //图片资源 pdf文件 需要独立ui显示
  // if(type == 24){pl
  // 	return  context.$router.push('/boardpdf' + fileId);//context.$router.push('/student/courseware/res/board/' + fileId);
  // }

  let fileType = util.getFileType(saveName);
  //若允许下载则不进入预览方法_this.allowDownloadLecture == 1 &&
  if (context.utils.isEmpty(saveName)) {
    openPdfview(context, fileId, url);
    return;
  }
  if ('pic' == fileType) {
    return '';
  }
  if ('audio' == fileType) {
    //return  el.playAudio("https://m801.music.126.net/20200227152347/2e1c062c7544106c05d0da847d8914f6/jdyyaac/5258/060e/0153/e26f139b621daa5a3eee69732a8cfabb.m4a");
    return funRouter.openAudio(context, el, fileId, saveNameStr);
  }

  // if ('video' == fileType) {//'audio' == fileType ||
  // 	var userobj = window.sessionStorage.getItem('SC_USER');
  // 	var token, userId, type;
  // 	if (userobj != undefined && userobj != null && userobj != 'undefined') {
  // 		var user = JSON.parse(userobj);
  // 		token = user.token;
  // 		userId = user.id;
  // 		type = user.type;
  // 		url = url + '?token=' + token + '&userId=' + userId;
  // 	}
  // 	return funRouter.openVidio(context, el, fileId, url);
  // }

  openPdfview(context, fileId, url, saveNameStr);
};

/***
 *
 * @param context
 * @param url url 根据pic下载预览，没有就 = fileDownloadUrl
 * @param fileDownloadUrl
 * @param fileSize
 * @param attachFileName
 * @param fileId  文件下载ID
 * @param classId 班级ID
 */
export const downloadLecture = (context, url, fileDownloadUrl, fileSize, attachFileName, fileId, classId) => {

  let _this = context;
  context.$axios.post(context.stuApiUrl + '/courseware/file/download', context.$qs.stringify({
    fileId: fileId, classId: classId
  })).then(function (response) {
    if (!response.data.success) {
      return weui.alert(response.data.info);
    }
  }).catch(function (error) {
    console.log(error);
  });

  var u = navigator.userAgent;
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  if (isiOS) {
    return _this.$router.push({
      path: '/file-download-ios', query: {
        filePath: url, fileDownloadUrl: fileDownloadUrl, attachFileName: attachFileName,
        fileSize: funRouter.numberFileSize(fileSize)
      }
    })
  } else {
    window.location.href = fileDownloadUrl + url
  }
};



// WEBPACK FOOTER //
// ./src/components/pageRouter/pageRouter.js